module.exports = __webpack_public_path__ + "static/media/image_3.7ae8ce9e.jpg";